import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { MOBILE_WIDTH } from "../../../../../utils/HelperStyles";
import StyledButton from "../../../../StyledButton";

const styledModalScrollbar = css`
  /* ::-webkit-scrollbar {
    width: 7px;
  }

  ::-webkit-scrollbar-track {
    background: #dcdfe3;
  }

  ::-webkit-scrollbar-thumb {
    background: #848688;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555b5f;
  } */
`;

export const UpSaleContainer = styled.div<{ isModal?: boolean }>`
  height: ${(props) => (props.isModal ? "100%" : "75vh")};
  ${(props) => (props.isModal ? "padding-top: 3vh;" : "")};
  width: 1000px;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* padding-bottom: 40px; */
  padding: 40px 6% 40px 6%;
  background-color: white;
  border-radius: 100px;

  overflow-y: auto;

  @media (max-width: ${MOBILE_WIDTH}) {
    width: 100vw;
    height: 100vh;
  }

  @media (max-width: 1200px) {
    width: 80vw;
  }

  ${styledModalScrollbar}
`;

export const BuyButton = styled(StyledButton)`
  margin: 15px 0px;
  width: 80%;
  border-radius: 10px;
  height: 60px;
  background-color: #64a54f;
  color: #fff;
  border-color: #fff;
  font-size: 20px;
`;
